define.alias("shared/components/shared/locale", "settings/components/shared/locale");